import { Icon, type TIconProps } from '~/components/icon'
import { DISPLAY_NAME, useTagContext } from '../../tag'
import type { TagScopedProps } from '../../tag.types'

type TagIconProps = TIconProps

export const TagIcon = (props: TagIconProps) => {
  const { symbol, __scopeTag } = props as TagScopedProps<TagIconProps>
  const { variants } = useTagContext(DISPLAY_NAME, __scopeTag)

  const mapVariantColor: Record<string, TIconProps['color']> = {
    principal: 'colorLabelingTextPrincipalDefault',
    secondary: 'colorLabelingTextSecondaryDefault',
    onSale: 'colorLabelingTextOnsaleDefault',
    clubeDrogasil: 'colorLabelingTextClubeDefault',
    clubeRaia: 'colorLabelingTextClubeDefault',
    assinatura: 'colorLabelingTextAssinaturaDefault',
    medicamentoGeladeira: 'colorLabelingTextRefrigerateDefault',
    receitaObrigatoria: 'colorLabelingTextPrescriptionDefault',
    generico: 'colorLabelingTextGenericoDefault',
    referencia: 'colorLabelingTextReferenciaDefault',
    similar: 'colorLabelingTextSimilarDefault',
    stix: 'colorLabelingTextStixDefault',
  }

  const renderIconSymbol = () => {
    if (variants === 'onSale') {
      return 'rdicon-arrow-down'
    }
    return symbol
  }

  return (
    <Icon
      symbol={renderIconSymbol()}
      color={mapVariantColor[variants]}
      size="tiny"
      data-testid="tag-icon"
    />
  )
}
